export const cartActionAreaTheme = {
  root: {
    '&:hover $focusHighlight': {
      opacity: 0,
    },
  },
}
